import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

const Text = styled.div`
  p,
  ul,
  ol {
    font-size: 0.8125rem;
    line-height: 1.3;
  }

  sub {
    vertical-align: sub;
    font-size: 75%;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    line-height: 1.3;
    font-weight: 700;
  }

  strong {
    font-weight: 700;
  }

  a {
    color: inherit;
    text-decoration: underline;

    &:hover,
    &:focus {
      color: inherit;
    }
  }

  p + p,
  p + ul,
  p + ol,
  ul + p,
  ul + ul,
  ul + ol {
    margin-top: 10px;
  }

  ul {
    padding-left: 1.2em;
  }

  li {
    list-style: outside disc;
  }

  li + li {
    margin-top: 3px;
  }
`

const Richtext = ({ children, className }) => {
  return <Text className={className}>{children}</Text>
}

Richtext.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Richtext
